import { render } from "./RoadSignsView.vue?vue&type=template&id=4d62aa1a&scoped=true"
import script from "./RoadSignsView.vue?vue&type=script&lang=js"
export * from "./RoadSignsView.vue?vue&type=script&lang=js"

import "./RoadSignsView.vue?vue&type=style&index=0&id=4d62aa1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d62aa1a"]])

export default __exports__